import { IonButton, IonIcon, IonListHeader } from '@ionic/react';
import ExploreListItem from 'components/listElements/ExploreListItem/ExploreListItem';
import { ExploreElement } from 'models/ExploreElementModel/ExploreElementModel';
import { FunctionComponent, useState } from 'react';
import { Trans } from 'react-i18next';
import Icon from '../../../components/icons/Icon';

interface PeopleSectionProps {
  people: ExploreElement[];
  activeTab: number;
  openPersonModal: (person: ExploreElement, score: number) => void;
}

const PeopleSection: FunctionComponent<PeopleSectionProps> = (
  props: PeopleSectionProps
) => {
  const [visiblePeopleCount, setVisiblePeopleCount] = useState(3);
  const { people, activeTab, openPersonModal } = props;

  if (people.length === 0) {
    return null; // Return null if there are no people to display
  }

  return (
    <div
      className="section-container"
      style={{ marginBottom: '16px', marginRight: '16px' }}
    >
      {/* People Header */}
      <IonListHeader style={{ paddingLeft: '0', marginBottom: '8px' }}>
        {
          <Icon
            name="PersonIroIcon"
            size="default"
            color="--ion-color-primary"
            marginLeft={8}
            marginRight={4}
            style={{ backgroundColor: 'transparent' }}
          />
        }
        <Trans i18nKey="PEOPLE">People</Trans>
        <span
          style={{
            marginLeft: '8px',
            fontSize: '12px',
            color: 'var(--ion-color-primary)',
          }}
        >
          ({people.length})
        </span>
      </IonListHeader>
      <div className="items-container">
        {people.slice(0, visiblePeopleCount).map((item, idx) => (
          <div key={`${item.id}_${idx}`} style={{ marginBottom: '4px' }}>
            <ExploreListItem
              item={item}
              isFriend={activeTab === 1}
              onOpenPersonModal={(person, score) =>
                openPersonModal(person, score)
              }
            />
          </div>
        ))}

        {people.length > visiblePeopleCount && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '0',
              paddingTop: '0',
            }}
          >
            {/* People Load More Button */}
            <IonButton
              fill="clear"
              size="small"
              className="load-more-button people"
              onClick={() => setVisiblePeopleCount((prev) => prev + 10)}
              style={{
                '--border-color': 'transparent',
                '--color': 'var(--ion-color-warning)',
                '--background': 'transparent',
                '--background-hover': 'var(--ion-color-warning-tint)',
                '--color-hover': 'var(--ion-color-warning-contrast)',
                boxShadow: 'none',
              }}
            >
              <Icon
                name="PersonIroIcon"
                size="small"
                color="--ion-color-secondary"
                marginRight={4}
                style={{ backgroundColor: 'transparent' }}
              />
              <Trans
                i18nKey="LOAD_MORE_PEOPLE"
                values={{ count: people.length - visiblePeopleCount }}
              >
                {people.length - visiblePeopleCount} weitere Personen anzeigen
              </Trans>
            </IonButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default PeopleSection;
